import { connect } from 'react-redux'
import Color from '../Components/Color'
import { mapStateToProps, mapDispatchToProps } from '../Utils/mapToProps'

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Color)
